// extracted by mini-css-extract-plugin
export default {"Container":"ModalFooter_Container__bt4VZ"};